import type { Component } from 'vue'

import { IconInfo } from '@ds/icons/IconInfo'

import { FAQ_CATEGORIES_CONFIG } from './FAQCategories.constants'

export function getCategoryIcon(categoryId: number): Component {
  return FAQ_CATEGORIES_CONFIG[categoryId.toString()]?.icon ?? IconInfo
}

export function getCategoryDataQA(categoryId: string): string {
  return (
    FAQ_CATEGORIES_CONFIG[categoryId]?.dataQa ?? `faq-category-${categoryId}`
  )
}
